import { render } from "./PatientCreateOphthalmicDiseases.vue?vue&type=template&id=4dcda042&scoped=true"
import script from "./PatientCreateOphthalmicDiseases.vue?vue&type=script&lang=js"
export * from "./PatientCreateOphthalmicDiseases.vue?vue&type=script&lang=js"

import "./PatientCreateOphthalmicDiseases.vue?vue&type=style&index=0&id=4dcda042&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dcda042"]])

export default __exports__